package meineglasfaser.frontend.www.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ariaLabel
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.frontend.common.components.widgets.PromLogo
import meineglasfaser.frontend.common.components.widgets.PromLogoType
import meineglasfaser.frontend.common.components.widgets.ThemeToggle
import meineglasfaser.frontend.www.components.layouts.CONTAINER_CLASS
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Ul

@Composable
fun RegisterHeader() {
    Header(attrs = { classes(CONTAINER_CLASS) }) {
        IncidentBanner()
        Nav(attrs = {
            role("navigation")
            ariaLabel("Hauptnavigation")
        }) {
            Ul {
            }
            Ul {
                Li {
                    Anchor(href = "/registrierung") {
                        PromLogo(PromLogoType.SSI)
                    }
                }
            }
            Ul {
                Li {
                    ThemeToggle()
                }
            }
        }
    }
}
